import TaxiCorporationCargoTaxiContractListResponse, {
  TaxiCorporationCargoTaxiContractListResponseDataItem,
} from "../../../../api/raily/taxi-corporation/cargo-taxi-contract/list/taxi-corporation-cargo-taxi-contract-list.response";
import TaxiCorporationCargoTaxiContractList, {
  TaxiCorporationCargoTaxiContractListItem,
} from "./taxi-corporation-cargo-taxi-contract-list";

const createDataItem = (
  responseDataItem: TaxiCorporationCargoTaxiContractListResponseDataItem,
): TaxiCorporationCargoTaxiContractListItem => {
  return {
    allowChargeDuringRide: responseDataItem.allowChargeDuringRide,
    allowChargeWhileApproaching: responseDataItem.allowChargeWhileApproaching,
    allowChargeWhileReturning: responseDataItem.allowChargeWhileReturning,
    cargoCompany: responseDataItem.cargoCompany,
    contactPassengerAfterMinutes: responseDataItem.contactPassengerAfterMinutes,
    disabled: responseDataItem.disabled,
    discountLimit: responseDataItem.discountLimit,
    distanceRate: responseDataItem.distanceRate,
    haltingTimeAfterMinutes: responseDataItem.haltingTimeAfterMinutes,
    haltingTimeRate: responseDataItem.haltingTimeRate,
    id: responseDataItem.id,
    model: responseDataItem.model,
    publishingAllowed: responseDataItem.publishingAllowed,
    validSince: responseDataItem.validSince,
    validTo: responseDataItem.validTo,
  };
};

const createData = (
  responseData: TaxiCorporationCargoTaxiContractListResponseDataItem[],
): TaxiCorporationCargoTaxiContractListItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: TaxiCorporationCargoTaxiContractListResponse,
): TaxiCorporationCargoTaxiContractList => {
  return {
    data: createData(response.data),
  };
};

const taxiCorporationCargoTaxiContractListFactory = {
  create,
};

export default taxiCorporationCargoTaxiContractListFactory;
